import React from 'react';
import ProjectModel from '../../models/ProjectModel';
import FormatUtils from '../../utils/FormatUtils.js';


export interface ProjectCardProps {
    project: ProjectModel
    handleProjectClicked: (project: ProjectModel) => void
}

const ProjectNewsItemCard: React.FC<ProjectCardProps> = ({ project, handleProjectClicked }) => {

    let startedOn: string = '';
    let deadline: string = '';

    const formatUtils = new FormatUtils();
    startedOn = formatUtils.formatDate(project.startedOn);
    if (project.deadline) {
        deadline = formatUtils.formatDate(project.deadline);
    }

    var backgroundColor = 'Green';
    var status = project.projectStatus;

    function ProjectClicked() {
        handleProjectClicked(project);
    }

    return (
        <a onClick={ProjectClicked}>
        <div style={{ width: 276, height: 311, overflow: 'hidden', margin: 5 }}>
            <div className="card card-user">
                <div className="content" style={{ padding: 0, maxHeight: 274 }}>
                   {project.thumbnailUrl && <img style={{ width: 274, height: 274 }} src={project.thumbnailUrl} alt="..." />}
                </div>
                <div style={{ padding: 5, overflow: 'auto' }}>
                    <div style={{ margin: 0, height: 25, maxHeight: 25, overflow: 'hidden', fontSize: 16 }}>{project.name}</div>
                </div>

            </div>
        </div>
        </a>
    );
}

export default ProjectNewsItemCard;